export default [
  {
    pk: 1,
    page_name: 'Riesgo',
    indicators: [
      {
        name: 'Riesgo',
        uuid: 'e7087cae-b4bc-479e-95bb-3776e7413c11'
      }
    ]
  },
  {
    pk: 2,
    page_name: 'Tamizaje',
    indicators: [
      {
        name: 'Tamizaje',
        uuid: '5710bc5f-cbc3-4e23-b3b6-4b5c6b74f354'
      }
    ]
  },
  {
    pk: 3,
    page_name: 'Pulmón',
    indicators: [
      /* {
        name: 'Oncología',
        uuid: '6730287b-022b-4f9d-bffb-8d127f490f25'
      } */
    ]
  },
  {
    pk: 4,
    page_name: 'Unindad funcional 4',
    indicators: [
      {
        name: 'Oncología',
        uuid: '6730287b-022b-4f9d-bffb-8d127f490f25'
      }
    ]
  },
  {
    pk: 5,
    page_name: 'Unindad funcional 5',
    indicators: [
      {
        name: 'Indicador',
        uuid: ''
      }
    ]
  },
  {
    pk: 6,
    page_name: 'Unindad funcional 6',
    indicators: [
      {
        name: 'Indicador',
        uuid: ''
      }
    ]
  },
  {
    pk: 7,
    page_name: 'Unindad funcional 7',
    indicators: [
      {
        name: 'Indicador',
        uuid: ''
      }
    ]
  },
  {
    pk: 8,
    page_name: 'Óseo',
    indicators: []
  },
  {
    pk: 9,
    page_name: 'Tórax',
    indicators: []
  },
  {
    pk: 10,
    page_name: 'Abdomen y pelvis',
    indicators: []
  },
  {
    pk: 11,
    page_name: 'Leucemias',
    indicators: []
  },
  {
    pk: 12,
    page_name: 'Histiocitosis',
    indicators: []
  },
  {
    pk: 13,
    page_name: 'SNC',
    indicators: []
  },
  {
    pk: 14,
    page_name: 'Linfomas',
    indicators: []
  },
  {
    pk: 15,
    page_name: 'Piel y tejidos',
    indicators: [
    ]
  },
  {
    pk: 16,
    page_name: 'Mama',
    indicators: [
    ]
  },
  {
    pk: 17,
    page_name: 'Cérvix',
    indicators: [

    ]
  },
  {
    pk: 18,
    page_name: 'Próstata',
    indicators: [
    ]
  },
  {
    pk: 19,
    page_name: 'Colon y recto',
    indicators: [
    ]
  },
  {
    pk: 20,
    page_name: 'Estomago',
    indicators: [
    ]
  },
  {
    pk: 21,
    page_name: 'Linfoma no hodking',
    indicators: [
    ]
  },
  {
    pk: 22,
    page_name: 'Melanomas',
    indicators: [
    ]
  },
  {
    pk: 23,
    page_name: 'Sarcomas',
    indicators: [
    ]
  },
  {
    pk: 24,
    page_name: 'Germinal',
    indicators: [
    ]
  },
  {
    pk: 25,
    page_name: 'Leucemias',
    indicators: [
    ]
  },
  {
    pk: 26,
    page_name: 'Cabeza y cuello',
    indicators: [
      {
        name: 'Indicador',
        uuid: ''
      }
    ]
  },
  {
    pk: 27,
    page_name: 'No priorizados',
    indicators: [
    ]
  },
  {
    pk: 28,
    page_name: 'Hemofilia CAC',
    indicators: [
      {
        name: 'Seguimiento frecuencias',
        uuid: 'c81202fe-4326-4bef-bad5-cbb5e142cc6a'
      },
      {
        name: 'Seguimiento calidad de vida',
        uuid: '101da158-d5ff-4bc9-9ee9-3d421b060cc3'
      }
    ]
  },
  {
    pk: 29,
    page_name: 'Eventos',
    indicators: []
  },
  {
    pk: 30,
    page_name: 'Mama',
    indicators: [
      {
        name: 'Indicador',
        uuid: ''
      }
    ]
  },
  {
    pk: 31,
    page_name: 'Otros',
    indicators: []
  },
  {
    pk: 32,
    page_name: 'Sin clasificar',
    indicators: []
  },
  {
    pk: 33,
    page_name: 'Colon y recto',
    indicators: [
      {
        name: 'Indicador',
        uuid: ''
      }
    ]
  },
  {
    pk: 34,
    page_name: 'Estomago',
    indicators: [
      {
        name: 'Indicador',
        uuid: ''
      }
    ]
  },
  {
    pk: 35,
    page_name: 'Linfoma no hodking',
    indicators: [
      {
        name: 'Indicador',
        uuid: ''
      }
    ]
  },
  {
    pk: 36,
    page_name: 'Melanomas',
    indicators: [
      {
        name: 'Indicador',
        uuid: ''
      }
    ]
  },
  {
    pk: 37,
    page_name: 'Sarcomas',
    indicators: [
      {
        name: 'Indicador',
        uuid: ''
      }
    ]
  },
  {
    pk: 38,
    page_name: 'Germinal',
    indicators: [
      {
        name: 'Indicador',
        uuid: ''
      }
    ]
  },
  {
    pk: 39,
    page_name: 'Leucemias',
    indicators: [
      {
        name: 'Indicador',
        uuid: ''
      }
    ]
  },
  {
    pk: 40,
    page_name: 'Cabeza y cuello',
    indicators: [
      {
        name: 'Indicador',
        uuid: ''
      }
    ]
  },
  {
    pk: 41,
    page_name: 'No priorizados',
    indicators: [
      {
        name: 'Indicador',
        uuid: ''
      }
    ]
  }
] as WorkUnit[];
